// extracted by mini-css-extract-plugin
module.exports = {"list":"DashboardInfoCard_list__2kl1r","card":"DashboardInfoCard_card__2ifqA","decimal":"DashboardInfoCard_decimal__2ipsE"};